import React, { useEffect, useState } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import { FormSubtitle } from '../styled';
import ThirdPartyIdField from './ThirdPartyIdField';
import { UAppThirdPartyId } from '../../models/AugmentedClasses';

import { TAppContact, TAppThirdPartyIdSource } from 'TProtocol/common/models';
import reject from 'lodash/reject';

interface Props {
  contact: TAppContact;
  onChange: (contact: TAppContact) => void;
}

export enum IUThirdPartyIdLabel {
  PersonalThirdPartyId = 1,
  ProfessionalThirdPartyId,
  OtherThirdPartyId
}

export interface ThirdPartyIdObject {
  thirdPartyId: UAppThirdPartyId;
  label: IUThirdPartyIdLabel;
}

const ThirdPartyIdFields = ({ contact, onChange }: Props) => {
  const [thirdPartyIds, setThirdPartyIds] = useState<ThirdPartyIdObject[]>([]);

  useEffect(() => {
    const thirdPartyIds: ThirdPartyIdObject[] = [];

    if (contact.personalThirdPartyIds) {
      contact.personalThirdPartyIds.forEach((thirdPartyId) => {
        thirdPartyIds.push({
          thirdPartyId,
          label: IUThirdPartyIdLabel.PersonalThirdPartyId
        });
      });
    }

    if (contact.professionalThirdPartyIds) {
      contact.professionalThirdPartyIds.forEach((thirdPartyId) => {
        thirdPartyIds.push({
          thirdPartyId,
          label: IUThirdPartyIdLabel.ProfessionalThirdPartyId
        });
      });
    }

    if (contact.otherThirdPartyIds) {
      contact.otherThirdPartyIds.forEach((thirdPartyId) => {
        thirdPartyIds.push({
          thirdPartyId,
          label: IUThirdPartyIdLabel.OtherThirdPartyId
        });
      });
    }

    setThirdPartyIds(thirdPartyIds);
  }, [contact]);

  const handleDelete = (thirdPartyId: ThirdPartyIdObject) => {
    removeThirdPartyId(thirdPartyId);
    onChange(contact);
  };

  const handleChange = (thirdPartyId: ThirdPartyIdObject, value: string, fieldAttribute: 'source' | 'value') => {
    if (fieldAttribute === 'source') {
      thirdPartyId.thirdPartyId.source = +value as TAppThirdPartyIdSource;
    } else if (fieldAttribute === 'value') {
      thirdPartyId.thirdPartyId.value = value;
    }

    onChange(contact);
  };

  const removeThirdPartyId = (thirdPartyId: ThirdPartyIdObject) => {
    if (thirdPartyId.label === IUThirdPartyIdLabel.PersonalThirdPartyId) {
      contact.personalThirdPartyIds = reject(
        contact.personalThirdPartyIds as UAppThirdPartyId[],
        { _key: thirdPartyId.thirdPartyId._key }
      );
    } else if (thirdPartyId.label === IUThirdPartyIdLabel.ProfessionalThirdPartyId) {
      contact.professionalThirdPartyIds = reject(
        contact.professionalThirdPartyIds as UAppThirdPartyId[],
        { _key: thirdPartyId.thirdPartyId._key }
      );
    } else if (thirdPartyId.label === IUThirdPartyIdLabel.OtherThirdPartyId) {
      contact.otherThirdPartyIds = reject(
        contact.otherThirdPartyIds as UAppThirdPartyId[],
        { _key: thirdPartyId.thirdPartyId._key }
      );
    }
  };

  // const setThirdPartyId = (label: IUThirdPartyIdLabel, thirdPartyId: TAppThirdPartyId) => {
  //   if (label === IUThirdPartyIdLabel.PersonalThirdPartyId) {
  //     if (!contact.personalThirdPartyIds) {
  //       contact.personalThirdPartyIds = [];
  //     }
  //     contact.personalThirdPartyIds.push(thirdPartyId);
  //   } else if (label === IUThirdPartyIdLabel.ProfessionalThirdPartyId) {
  //     if (!contact.professionalThirdPartyIds) {
  //       contact.professionalThirdPartyIds = [];
  //     }
  //     contact.professionalThirdPartyIds.push(thirdPartyId);
  //   } else if (label === IUThirdPartyIdLabel.OtherThirdPartyId && thirdPartyId !== undefined) {
  //     if (!contact.otherThirdPartyIds) {
  //       contact.otherThirdPartyIds = [];
  //     }
  //     contact.otherThirdPartyIds.push(thirdPartyId);
  //   }
  // };

  return <>
    <FormSubtitle>Social Profiles</FormSubtitle>

    {
      thirdPartyIds.map((thirdPartyId) => {
        return <Row key={thirdPartyId.thirdPartyId._key}>
          <Col>
            <ThirdPartyIdField
              thirdPartyId={thirdPartyId}
              onDelete={handleDelete}
              onChange={handleChange}
            />
          </Col>
        </Row>;
      })
    }

  </>;
};

export default ThirdPartyIdFields;
